import type { Phoneme } from "@/generated/graphql";
import { nonDraggablesTypeSlide } from "@/lib/constants/slides";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { addElement } from "@/store/slideEditorSlice";
import type {
  ArrowType,
  LineElement,
  LineStyle,
  PhonicElement,
  ShapeElement,
} from "@ai-teach/types";
import toast from "react-hot-toast";

export interface LineConfig {
  lineStyle: LineStyle;
  startArrow?: ArrowType;
  endArrow?: ArrowType;
}

export function useAddPhonicElement() {
  const dispatch = useAppDispatch();
  const { slide, canvasSize } = useAppSelector((state) => state.slideEditor.present);

  const slideType = slide?.type;
  const knowledgeArea = slide?.knowledgeArea;

  const handleAddPhonicElement = (
    mediaAsset: {
      src: string;
      id: string;
      filename: string;
    },
    phoneme: Phoneme
  ) => {
    if (!slideType) return;
    if (
      !knowledgeArea ||
      (nonDraggablesTypeSlide[slideType] as readonly string[])?.includes(knowledgeArea)
    ) {
      toast.error("This slide type doesn't support phonic element", {
        id: "slide-phonic-limit",
      });
      return;
    }

    const canvasWidth = canvasSize.height * canvasSize.aspectRatio;
    const size = { width: 90, height: 90 };

    dispatch(
      addElement({
        type: "phonic" as const,
        position: {
          x: Math.round((canvasWidth - size.width) / 2),
          y: Math.round((canvasSize.height - size.height) / 2),
        },
        border: {
          lineStyle: "none",
          stroke: "transparent",
          strokeWidth: 3,
          cornerRadius: 0,
        },
        size,
        media: mediaAsset,
        phoneme: phoneme.phoneme,
        phonemeType: phoneme.phonemeType,
        autoPlay: false,
        loop: false,
      } as PhonicElement)
    );
  };

  return {
    handleAddPhonicElement,
  };
}
